import { APP_BASE_HREF, LocationStrategy, PathLocationStrategy } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { ErrorHandler, InjectionToken, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MissingTranslationHandler, TranslateLoader as NgXTranslateLoader, TranslateModule } from "@ngx-translate/core";
import { NotificationModule } from "@progress/kendo-angular-notification";
import { NgxMaskModule } from "ngx-mask";
import { BrowserCommunicationModule } from "../app.services/browser.communication/browser.communication.module";
import { WrapExceptionHandler } from "../app.services/exception/wrap.exception.handler";
import { LoginProvidersModule } from "../app.services/login/login.module.providers";
import { RtlModule } from "../common/rtl/rtl.module";
import { CPTranslateModule } from "../common/translate";
import { MissingTranslationHandler as CPMissingTranslationHandler } from "../common/translate/services/missing.translation.handler";
import { TranslateLoader as CustomTranslateLoader } from "../common/translate/services/translate.loader";
import { TranslateProxy } from "../common/translate/services/translate.proxy";
import { SvgIconsModule } from "../common/ui/components/svg.icons/svg.icons.module";
//import { SvgIconsProvidersModule } from "../common/ui/components/svg.icons/svg.icons.providers.module";
import { MarkdownModule } from "ngx-markdown";
import { UnauthorizedInterceptor } from '../common/http/interceptors/unauthorized.interceptor';
import { EnvironmentModule } from "../platform/environment.module";
import { ThemeChangerProxy } from "../puzzlehead/components/theme.example/theme.changer/theme.changer.proxy";
import { APPRoutingModule } from "./app.routes";
import { GlobalAppProvidersModule } from "./global.app.providers";
import { RotateScreenComponent } from "./global/rotate.screen/rotate.screen.component";
import { VueRISAppComponent } from "./global/vue.cip.component";

export class AuthenticatedModeContainer{
	private _mode: boolean = false;
	get mode(): boolean {
		return this._mode;
	}
	set mode(value: boolean) {
		this._mode = value;
	}
}

export class WIM_Locale_Container{
	private locale: string = "en-US";//this is the default kendo locale so we use the same default
	getLocale(): string {
		return this.locale;
	}
	setLocale(value: string) {
		this.locale = value;
	}
}

export let AuthenticatedMode: InjectionToken<AuthenticatedModeContainer> = new InjectionToken("AuthenticationMode");
export let WIM_LOCALE_ID: InjectionToken<WIM_Locale_Container> = new InjectionToken("WIM_LOCATE_ID");

// export function baseHrefFactory() {
// 	debugger;
// 	const baseResourceUrl = window['__ris_global_vars__'].baseResourceUrl;
// 	if (baseResourceUrl === '/assets/') {
// 		return baseResourceUrl;
// 	}
// 	const expectedBaseHref = baseResourceUrl.split('/')[1];
// 	const currentBaseHref = window.location.pathname.split('/')[1];
// 	if (expectedBaseHref.toLowerCase() === currentBaseHref.toLowerCase() && expectedBaseHref !== currentBaseHref) {
// 		// The two base hrefs are the same, but not the same case.
// 		// Redirect the user to the correct base href.
// 		const newLocation = window.location.href.replace(currentBaseHref, expectedBaseHref);
// 		window.location.replace(newLocation);
// 	}
// 	return '/' + expectedBaseHref + '/';
// }

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
	bootstrap: [ VueRISAppComponent ],
	declarations: [
		VueRISAppComponent,
		RotateScreenComponent
	],
	imports: [
		BrowserModule,
		RtlModule.forRoot(),
		CPTranslateModule.forRoot(),
		LoginProvidersModule.forRoot(),
		SvgIconsModule,
		//SvgIconsProvidersModule.forRoot(),
		GlobalAppProvidersModule.forRoot(),
		TranslateModule.forRoot({
			loader: {
				provide: NgXTranslateLoader,
				useClass: (CustomTranslateLoader),
				deps: [TranslateProxy]
			},
			missingTranslationHandler:
				{ provide: MissingTranslationHandler, useClass: CPMissingTranslationHandler}}),
		APPRoutingModule,
		BrowserAnimationsModule,		
        MarkdownModule.forRoot(),
		EnvironmentModule.forRoot(),
		BrowserCommunicationModule.forRoot(),
		NgxMaskModule.forRoot(), 
		HttpClientModule,
		NotificationModule, // must be imported for kendo NotificationService provider to be available 
	],
	providers: [				
		{ provide: AuthenticatedMode, useClass: AuthenticatedModeContainer },
		TranslateProxy,
		ThemeChangerProxy,
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		{provide: APP_BASE_HREF, useValue: window['__ris_global_vars__'].baseResourceUrl},
		{provide:WIM_LOCALE_ID,useClass:WIM_Locale_Container},
		//{ provide: APP_BASE_HREF, useFactory: baseHrefFactory},
		{ provide: ErrorHandler, useClass: WrapExceptionHandler },
		{ provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true }
	]
})
export class AppModule { }

